import { normalizeTimeInput } from 'functions/general/dateFormat.js';
import { getMax } from "store/reducers/helpers/utils.js";


const modifyInput = (inputValue, dataType, data, columnName) => {
    /**
     * Modifies the input value based on the data type
     * @param {string} inputValue - The input value
     * @param {string} dataType - The data type
     * @param {array} data - The data, only required if the data type is 'id'
     * @param {string} columnName - The column name, only required if the data type is 'id'
     */
    let newValue = inputValue;
    if (dataType === 'time') {
        newValue = normalizeTimeInput(inputValue);
      }
      if (dataType === 'id') {
        if (!data) {
            throw new Error('Data is not defined')
        }
        if (!columnName) {
            throw new Error('columnName is not defined')
        }
        if (data.length === 0) {
          newValue = 1;
        } else {
          const maxRow = getMax(data, columnName)
          newValue = maxRow[columnName] + 1;
        }
      }
      if (dataType === 'multi-dropdown') {
        if (typeof inputValue === 'string' || inputValue instanceof String) {
          if (inputValue.startsWith('[') && inputValue.endsWith(']')) {
            try {
              newValue = JSON.parse(inputValue.replace(/'/g, '"'));
            } catch (e) {
              newValue = inputValue.split(',').map(element => element.trim());
            }
            } else {
              newValue = inputValue.split(',')
              newValue = newValue.map(element => element.trim())
            }
          }
        // If already an array, then make sure all elements are strings and remove nulls
        if (Array.isArray(inputValue)) {
          newValue = inputValue.filter(element => element != null).map(element => element.toString());
        }
      }
      if (dataType === 'boolean') {
        if (typeof inputValue === 'string' || inputValue instanceof String) {
          if (inputValue.toLowerCase() === 'true' || inputValue === '1') {
            newValue = true;
          } else if (inputValue.toLowerCase() === 'false' || inputValue === '0' || inputValue === '' || inputValue.toLowerCase() === 'null' || inputValue.toLowerCase() === 'undefined') {
            newValue = false;
          } else {
            newValue = true;
          }
      }
    }
    return newValue
}

export default modifyInput;